import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const memberCostsModule = {
  namespaced: true,
  state: () => ({
    defaultMemberCostList: [
      { category: 'Preventive annual exam, vaccinations and screenings', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Primary care visit (includes pediatricians)', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Visits with chosen primary care doctor', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Visits with other primary care doctors', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Centivo Care virtual primary care', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Specialist visit', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Behavioral health visit', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Lab test (such as blood work)', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Basic imaging (such as X-rays)', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Advanced imaging (such as MRIs & PET scans)', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Outpatient surgery', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Hospital stay', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Urgent care', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Emergency room', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: '', inNetwork: '', outOfNetwork: '', last: true }
    ],
    memberCostData: [
      { category: 'Preventive annual exam, vaccinations and screenings', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Primary care visit (includes pediatricians)', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Visits with chosen primary care doctor', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Visits with other primary care doctors', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Centivo Care virtual primary care', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Specialist visit', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Behavioral health visit', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Lab test (such as blood work)', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Basic imaging (such as X-rays)', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Advanced imaging (such as MRIs & PET scans)', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Outpatient surgery', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Hospital stay', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Urgent care', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: 'Emergency room', inNetwork: '', outOfNetwork: '', static: true, isDefault: true },
      { category: '', inNetwork: '', outOfNetwork: '', last: true }
    ],
    defaultRxCoverageData: [
      { category: 'Generic/Tier 1', userInput1: '', userInput2: '' },
      { category: 'Preferred Brand/Tier 2', userInput1: '', userInput2: '' },
      { category: 'Non-Preferred Brand/Tier 3', userInput1: '', userInput2: '' },
      { category: '', userInput1: '', userInput2: '', last: true }
    ],
    rxCoverageData: [
      { category: 'Generic/Tier 1', userInput1: '', userInput2: '' },
      { category: 'Preferred Brand/Tier 2', userInput1: '', userInput2: '' },
      { category: 'Non-Preferred Brand/Tier 3', userInput1: '', userInput2: '' },
      { category: '', userInput1: '', userInput2: '', last: true }
    ],
    defaultRxCoverageSpecialtyList: [
      { category: 'Specialty/Tier 4', userInput1: '', userInput2: '' },
      { category: '', userInput1: '', userInput2: '', last: true }
    ],
    rxCoverageSpecialtyList: [
      { category: 'Specialty/Tier 4', userInput1: '', userInput2: '' },
      { category: '', userInput1: '', userInput2: '', last: true }
    ],
    checkedMemberCostData: [],
    checkedRxCoverageData: [],
    checkedRxCoverageSpecialtyData: [],
    customMemberCostHeaders: { tier1: '', tier2: '' },
    customRxHeaders: null,
    customRxSpecialtyHeaders: null
  }),
  mutations: {
    setMemberCostData (state, memberCostData) {
      state.memberCostData = memberCostData
    },

    setRxCoverageData (state, rxCoverageData) {
      state.rxCoverageData = rxCoverageData
    },

    setRxCoverageSpecialtyData (state, rxCoverageSpecialtyData) {
      state.rxCoverageSpecialtyList = rxCoverageSpecialtyData
    },

    setCheckedMemberCostData (state, checkedMemberCostData) {
      state.checkedMemberCostData = checkedMemberCostData
    },

    setCheckedRxCoverageData (state, checkedRxCoverageData) {
      state.checkedRxCoverageData = checkedRxCoverageData
    },

    setCheckedRxCoverageSpecialtyData (state, checkedRxCoverageSpecialtyData) {
      state.checkedRxCoverageSpecialtyData = checkedRxCoverageSpecialtyData
    },

    setCustomMemberCostHeaders (state, customMemberCostHeaders) {
      state.customMemberCostHeaders = customMemberCostHeaders
    },

    setCustomRxHeaders (state, customRxHeaders) {
      state.customRxHeaders = customRxHeaders
    },

    setCustomRxSpecialtyHeaders (state, customRxHeaders) {
      state.customRxSpecialtyHeaders = customRxHeaders
    }
  },
  actions: {
    async getMemberCostData ({ commit, getters, state }) {
      return new Promise((resolve, reject) => {
        commit('setMemberCostData', state.memberCostData)
        resolve(state.memberCostData)
      })
    },

    async getRXCoverageData ({ commit, getters, state }) {
      return new Promise((resolve, reject) => {
        commit('setRxCoverageData', state.rxCoverageData)
        resolve(state.rxCoverageData)
      })
    },

    async getCustomMemberCostHeaders ({ commit, getters, state }) {
      return new Promise((resolve, reject) => {
        commit('setCustomMemberCostHeaders', state.customMemberCostHeaders)
        resolve(state.customMemberCostHeaders)
      })
    },

    async getCustomRxHeaders ({ commit, getters, state }) {
      return new Promise((resolve, reject) => {
        commit('setCustomRxHeaders', state.customRxHeaders)
        resolve(state.customRxHeaders)
      })
    },

    async getCustomRxSpecialtyHeaders ({ commit, getters, state }) {
      return new Promise((resolve, reject) => {
        commit('setCustomRxHeaders', state.customRxSpecialtyHeaders)
        resolve(state.customRxSpecialtyHeaders)
      })
    },

    async getRxCoverageSpecialtyData ({ commit, getters, state }) {
      return new Promise((resolve, reject) => {
        commit('setRxCoverageSpecialtyData', state.rxCoverageSpecialtyList)
        resolve(state.rxCoverageSpecialtyList)
      })
    },

    async setMemberCostData ({ commit, getters, state }, memberCostData) {
      commit('setMemberCostData', memberCostData)
    },

    async setRxCoverageData ({ commit, getters, state }, rxCoverageData) {
      commit('setRxCoverageData', rxCoverageData)
    },

    async setRxCoverageSpecialtyData ({ commit, getters, state }, rxCoverageSpecialtyData) {
      commit('setRxCoverageSpecialtyData', rxCoverageSpecialtyData)
    },

    async setCheckedMemberCostData ({ commit, getters, state }, checkedMemberCostData) {
      commit('setCheckedMemberCostData', checkedMemberCostData)
    },

    async setCheckedRxCoverageData ({ commit, getters, state }, checkedRxCoverageData) {
      commit('setCheckedRxCoverageData', checkedRxCoverageData)
    },

    async setCheckedRxCoverageSpecialtyData ({ commit, getters, state }, checkedRxCoverageSpecialtyData) {
      commit('setCheckedRxCoverageSpecialtyData', checkedRxCoverageSpecialtyData)
    },

    async resetMemberCostPageData ({ commit, getters, state }) {
      state.rxCoverageData = state.defaultRxCoverageData.map(costs => ({ ...costs }))
      state.rxCoverageSpecialtyList = state.defaultRxCoverageSpecialtyList.map(costs => ({ ...costs }))
      state.checkedMemberCostData = []
      state.checkedRxCoverageData = []
      state.checkedRxCoverageSpecialtyData = []
      state.memberCostData = state.defaultMemberCostList.map(costs => ({ ...costs }))
      state.customMemberCostHeaders = {
        tier1: '',
        tier2: ''
      }
      state.customRxHeaders = {
        customHeader1: '',
        customHeader2: ''
      }
      state.customRxSpecialtyHeaders = {
        customHeader1: '',
        customHeader2: ''
      }
    },

    async setCustomMemberCostHeaders ({ commit, getters, state }, customMemberCostHeaders) {
      commit('setCustomMemberCostHeaders', customMemberCostHeaders)
    },

    async setCustomRxHeaders ({ commit, getters, state }, customRxHeaders) {
      commit('setCustomRxHeaders', customRxHeaders)
    },

    async setCustomRxSpecialtyHeaders ({ commit, getters, state }, customRxHeaders) {
      commit('setCustomRxSpecialtyHeaders', customRxHeaders)
    }
  },
  modules: {
  },
  getters: {
    getMemberCostData: state => state.memberCostData,
    getRxCoverageData: state => state.rxCoverageData,
    getCheckedMemberCostData: state => state.checkedMemberCostData,
    getCheckedRxCoverageData: state => state.checkedRxCoverageData,
    getCustomRxHeaders: state => state.customRxHeaders,
    getRxCoverageSpecialtyData: state => state.rxCoverageSpecialtyList,
    getCheckedRxCoverageSpecialtyData: state => state.checkedRxCoverageSpecialtyData,
    getCustomRxSpecialtyHeaders: state => state.customRxSpecialtyHeaders,
    getDefaultMemberCostList: state => state.defaultMemberCostList,
    getCustomMemberCostHeaders: state => state.customMemberCostHeaders
  }
}

export default memberCostsModule
